document.querySelectorAll( '.b-button-modal' ).forEach( ( block ) => {

	const modalButton = block.querySelector( '.js-button-modal a' );

	if ( !modalButton ) {

		return;

	}

	const modalButtonClose = block.querySelector( '.js-button-modal-close' );

	/**
	 * Toggles the visibility of a modal block by adding or removing the `active` class.
	 */
	const toggleModal = () => {

		block.classList.toggle( 'active' );

		if ( block.classList.contains( 'active' ) ) {

			document.documentElement.classList.add( 'no-scroll' );

		} else {

			document.documentElement.classList.remove( 'no-scroll' );

		}

	}

	modalButton.addEventListener( 'click', ( e ) => {

		e.preventDefault();

		toggleModal();

	} );

	modalButtonClose.addEventListener( 'click', ( e ) => {

		e.preventDefault();

		toggleModal();

	} );

} );
